import InlineEditField from '@components/v2/form/InlineEditField/InlineEditField';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import LangEnum from '../../../../../../../../../lang/LangEnum';
import { CatalogProductsTestIds } from '../../../../../../../../../utils/testIds/CatalogProducts.testIds';
import { AvailabilityEnum } from '../../../../../../../../products/ProductTypes';
import { useTranslation } from '../../../../../../../../translation/TranslationContext';
import { AvailabilityConditions } from '../../../../../../../catalog.types';
import { formatStockConditionInputValue } from '../../../../../../../creation/catalogCreationStock.utils';
import CatalogDetailField from '../../CatalogDetailField';
import { StockConditionField } from '../catalogGridCriteriaSection.types';
import { useCatalogGridCriteriaCardStyles } from '../styles/catalogGridCriteriaCard.styles';

interface ConfirmStockConditionParams {
  availability: AvailabilityEnum;
  field: StockConditionField;
  value: string;
}

interface CatalogGridCriteriaCardProps {
  availability: AvailabilityEnum;
  labelLang: LangEnum;
  conditions?: AvailabilityConditions;
  isDisabled: boolean;
  validate: (value: string) => string | undefined;
  onConfirm: (params: ConfirmStockConditionParams) => void;
}

const CatalogGridCriteriaCard = ({
  availability,
  labelLang,
  conditions,
  isDisabled,
  validate,
  onConfirm,
}: CatalogGridCriteriaCardProps) => {
  const { translate } = useTranslation();
  const { classes } = useCatalogGridCriteriaCardStyles();

  const renderConditionField = (field: StockConditionField, testId: string) => (
    <InlineEditField
      value={formatStockConditionInputValue(conditions?.[field])}
      isDisabled={isDisabled}
      validate={validate}
      testId={`${testId}-${availability}`}
      onConfirm={(value) => onConfirm({ availability, field, value })}
    />
  );

  return (
    <Stack sx={{ gap: 1 }}>
      <Typography
        variant="micro1"
        color="text.secondary"
        sx={(theme) => ({ pl: theme.spacing(0.75) })}
      >
        {translate(labelLang)}
      </Typography>
      <Stack direction="column" className={classes.availabilityFieldsContainer}>
        <CatalogDetailField
          maxWidth="60%"
          width="60%"
          label={LangEnum.CATALOG_MINIMUM_STOCK_PER_GRID}
          labelTextColor="text.primary"
          control={renderConditionField(
            'minTotalPieces',
            CatalogProductsTestIds.DETAILS_STOCK_MIN_TOTAL_PIECES,
          )}
        />
        <CatalogDetailField
          maxWidth="60%"
          width="60%"
          label={LangEnum.CATALOG_MINIMUM_SEQUENTIAL_SIZES}
          labelTextColor="text.primary"
          control={renderConditionField(
            'minSequentialSizes',
            CatalogProductsTestIds.DETAILS_STOCK_MIN_SEQUENTIAL_SIZES,
          )}
        />
      </Stack>
    </Stack>
  );
};

export default CatalogGridCriteriaCard;
